var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20a1.5 1.5 0 011.5-1.5h12A1.5 1.5 0 0115 20c0 .76.24 1.933.916 2.874.623.861 1.673 1.626 3.584 1.626a1.5 1.5 0 110 3H6c-2.289 0-3.864-.987-4.818-2.31A6.525 6.525 0 010 21.5V20zm13.395 4.5a8.077 8.077 0 01-1.242-3H3c0 .51.165 1.308.618 1.935C4.014 23.987 4.689 24.5 6 24.5h7.395z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5A1.5 1.5 0 006 5v15a1.5 1.5 0 01-3 0V5A4.5 4.5 0 017.5.5H24A1.5 1.5 0 0125.5 2v19.5c0 .99-.285 2.442-1.182 3.69-.954 1.322-2.529 2.31-4.818 2.31a1.5 1.5 0 110-3c1.311 0 1.986-.513 2.382-1.065.453-.627.618-1.425.618-1.935v-18h-15z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2A1.5 1.5 0 0124 .5c.99 0 2.442.285 3.69 1.182C29.012 2.636 30 4.211 30 6.5c0 2.289-.987 3.864-2.31 4.816A6.525 6.525 0 0124 12.5a1.5 1.5 0 110-3c.51 0 1.308-.165 1.935-.618C26.487 8.486 27 7.811 27 6.5c0-1.311-.513-1.986-1.065-2.382A3.533 3.533 0 0024 3.5 1.5 1.5 0 0122.5 2z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.638d48d8.svg";
export { ForwardRef as ReactComponent };